"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PosMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isLoading = lodash_1.default.get(result, "loading");
        const pointOfSale = lodash_1.default.get(result, "data.getPos");
        /* istanbul ignore next */
        const menus = pointOfSale.menus.map((m) => {
            var _a;
            return (Object.assign(Object.assign({}, m), { elements: (_a = m === null || m === void 0 ? void 0 : m.elements) === null || _a === void 0 ? void 0 : _a.map((e) => {
                    var _a, _b;
                    return (Object.assign(Object.assign({}, e), { inheritedFamily: (_b = (_a = e === null || e === void 0 ? void 0 : e.dish) === null || _a === void 0 ? void 0 : _a.dishGroup) === null || _b === void 0 ? void 0 : _b.label, inheritedLabel: e === null || e === void 0 ? void 0 : e.label }));
                }) }));
        });
        return {
            hasError,
            isLoading,
            pointOfSale: Object.assign(Object.assign({}, pointOfSale), { menus }),
        };
    }
}
exports.PosMapper = PosMapper;
